import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CustomStepCategoryEnum, ExecutionTypeEnum, StepBasicLayout, StepElements, User } from '../../../_models';
import { StepEmulatorService } from '../../../_services';

@Component({
  selector: 'step-advanced-settings',
  templateUrl: './step-advanced-settings.component.html',
  styleUrls: ['./step-advanced-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StepAdvancedSettingsComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() layout: StepBasicLayout;
  @Input() stepType: CustomStepCategoryEnum;
  @Input() user: User = null;

  stepElements = StepElements;
  executionTypes = ExecutionTypeEnum;
  actionList: FormArray;
  actions: FormGroup;
  selectedBillingCycle: null | number = null;
  userControlledNextBillingDate: boolean = true;
  userControlledMaxBillingDate: boolean = true;

  constructor(private stepEmulatorService: StepEmulatorService) {}

  ngOnInit() {
    const inputs = this.form.get('inputs') as FormArray;
    const firstInput = inputs && (inputs.at(0) as FormGroup);
    this.actionList = firstInput && (firstInput.get('actions') as FormArray);
    this.actions = this.actionList && (this.actionList.at(0) as FormGroup);

    if (this.isReactivateSubscription && this.actions) {
      this.selectedBillingCycle = this.actions.get('billing_interval_days').value;
      if (this.selectedBillingCycle > 0 && this.selectedBillingCycle !== null) {
        this.selectedBillingCycle = 1;
      }

      const next_bill_date_delay = this.actions.get('next_bill_date_delay').value;
      const max_bill_date_delay = this.actions.get('max_bill_date_delay').value;
      this.userControlledNextBillingDate = next_bill_date_delay === null;
      this.userControlledMaxBillingDate = max_bill_date_delay === null;
    }
  }

  updateBillingCycle() {
    if (this.selectedBillingCycle === null || this.selectedBillingCycle === 0) {
      this.actions.patchValue({ billing_interval_days: this.selectedBillingCycle });
    }
  }

  nextBillingDateUpdate() {
    if (this.userControlledNextBillingDate) {
      this.actions.patchValue({ next_bill_date_delay: null });
    }
  }

  maxBillingDateUpdate() {
    if (this.userControlledMaxBillingDate) {
      this.actions.patchValue({ max_bill_date_delay: null });
    }
  }

  toggleElement(element: StepElements) {
    this.stepEmulatorService.toggleElement(element);
  }

  isElementVisible(element: StepElements): boolean {
    return this.stepEmulatorService.isElementVisible(element);
  }

  get isReactivateSubscription() {
    return this.stepType === CustomStepCategoryEnum.ReActivateSubscriptionWithDiscount;
  }

  get isImmediate() {
    return this.actions && this.actions.get('execution_type').value === ExecutionTypeEnum.Immediate;
  }

  get isDelayed() {
    return this.actions && this.actions.get('execution_type').value === ExecutionTypeEnum.Delayed;
  }

  get isValidationOnly() {
    return this.actions && this.actions.get('execution_type').value === ExecutionTypeEnum.ValidationOnly;
  }
}
